import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { exportExcel, importExcel } from "../Classification/api";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";

function ManualClassificationModal({ showModal, handleCloseModal }) {
  const [reportType, setReportType] = useState("");
  const [approvedFile, setApprovedFile] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const { id } = useParams();

  const handleReportTypeChange = (event) => {
    setReportType(event.target.value);
  };

  const handleDownloadExcel = async () => {
    try {
      setDownloading(true);
      const body = {
        restaurant_id: id,
        report_type: reportType,
      };
      const response = await exportExcel(body);
      const binaryData = Uint8Array.from(atob(response.file), (char) =>
        char.charCodeAt(0)
      );

      // Create Blob and download
      const blob = new Blob([binaryData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "report.xlsx");

      setDownloading(false);
      toast.success("Excel downloaded successfully");
    } catch (error) {
      setDownloading(false);
      toast.error("Error downloading Excel");
      console.error("Error downloading Excel:", error);
    }
  };

  const handleSubmitApprovedExcel = async (event) => {
    event.preventDefault();
    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", approvedFile);
      const body = {
        restaurant_id: id,
        report_type: reportType,
      };
      formData.append("data", JSON.stringify(body));
      const response = await importExcel(formData);
      setUploading(false);
      toast.success(response.message);
    } catch (error) {
      setUploading(false);
      console.error("Error submitting approved Excel:", error);
      toast.error("Error submitting approved Excel");
    }
  };

  return (
    <>
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Manual Classification and Approval</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <select
            className="form-select"
            value={reportType}
            onChange={handleReportTypeChange}
          >
            <option value="">Select Report Type</option>
            <option value="product">Menu Mix</option>
            <option value="labor">Labor</option>
            <option value="discount">Discount</option>
          </select>
          <br />

          <Button
            className="my-1"
            variant="secondary"
            onClick={handleDownloadExcel}
            style={{ width: "100%" }}
          >
            {downloading && <Spinner animation="border" size="sm mx-2" />}
            Export Excel
          </Button>

          <br />
          <hr className="featurette-divider" />
          <label htmlFor="approvedFile mt-4 mb-2">Upload Approved Excel</label>
          <input
            className="form-control my-2"
            type="file"
            onChange={(event) => setApprovedFile(event.target.files[0])}
          />
          <Button
            className="my-2"
            variant="success"
            onClick={handleSubmitApprovedExcel}
            style={{ width: "100%" }}
          >
            {uploading && <Spinner animation="border" size="sm mx-2" />}
            Upload Excel
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ManualClassificationModal;
